"use client";

import { prefetchDNS } from "react-dom";

const DNS_PREFETCH_TARGETS = [
  "https://www.google-analytics.com",
  "https://www.googletagmanager.com",
  "https://js.stripe.com",
  "https://m.stripe.network",
];

export function ResourceHints() {
  for (const target of DNS_PREFETCH_TARGETS) {
    prefetchDNS(target);
  }

  return null;
}
